<template>
    <article class="page">
        <div class="page-content">
            <header v-if="title || $slots.header" :class="headerClasses">
                <h1 v-if="title" class="title">{{ title }}</h1>
                <slot name="header"/>
            </header>
            <slot/>
        </div>
    </article>
</template>

<script>
  export default {
    name: 'Page',

    props: {
      title: {
        type:     String,
        required: false,
      },

      stickyHeader: {
        type:    Boolean,
        default: false,
      },
    },

    computed: {
      headerClasses () {
        return {
          'page-header':        true,
          'page-header-sticky': this.stickyHeader,
        };
      },
    },

    methods: {},
  };
</script>

<style scoped>
    .page {
        display:         flex;
        justify-content: center;
        align-items:     flex-start;
        min-height:      100vh;
        padding-bottom:  4rem;
        background:      var(--color-white-bright);
    }

    .page-content {
        width:     100%;
        max-width: 86rem;
        padding:   1rem;
    }

    .page-header {
        display:         flex;
        justify-content: space-between;
        align-items:     flex-end;
    }

    .page-header.page-header-sticky {
        position:   sticky;
        top:        0;
        padding:    1rem 0;
        background: var(--color-white-bright);
        box-shadow: 0 2px 5px -5px rgba(0, 0, 0, 0.5), 0 -1rem 0 1rem var(--color-white-bright);
        z-index:    1;
    }

    .title {
        flex:           1 1 auto;
        margin:         1.25rem 0 2rem;
        padding-bottom: 2rem;
        border-bottom:  1px solid var(--color-gray-lighter);
        line-height:    1;
        font-size:      2.2rem;
        color:          var(--color-primary-shade);
    }
</style>
